import { ThemeEvents } from '@theme/events';
import { morph } from '@theme/morph';
import { Component } from '@theme/component';

class LowStockAlert extends Component {
  connectedCallback() {
    super.connectedCallback();
    const closestSection = this.closest('.shopify-section, dialog');
    closestSection?.addEventListener(ThemeEvents.variantUpdate, this.updateAlert);
  }

  disconnectedCallback() {
    super.disconnectedCallback();
    const closestSection = this.closest('.shopify-section, dialog');
    closestSection?.removeEventListener(ThemeEvents.variantUpdate, this.updateAlert);
  }

  /**
   * Updates the low stock alert.
   * @param {CustomEvent} event - The variant update event.
   */
  updateAlert = (event) => {
    if (event.detail.data.newProduct) {
      this.dataset.productId = event.detail.data.newProduct.id;
    } else if (event.target instanceof HTMLElement && event.target.dataset.productId !== this.dataset.productId) {
      return;
    }

    const newAlert = event.detail.data.html.querySelector('low-stock-alert-component');

    // If the new variant doesn't render an alert at all (e.g. plenty of stock),
    // just clear this one out instead of leaving stale content.
    if (!newAlert) {
      this.innerHTML = '';
      return;
    }

    morph(this, newAlert, { childrenOnly: true });
  };
}

if (!customElements.get('low-stock-alert-component')) {
  customElements.define('low-stock-alert-component', LowStockAlert);
}